// The words each sales book's filter bar names its filters by, keyed by the
// URL key a saved view stores (V5, PR-E4 wave 6; spec 16 §4 Errors on save).
// A saved-view refusal that names a stored filter reads these, so the quote
// book's `origin` is "From", as its bar says, and not the views layer's
// screen-independent "Origin". Each map holds every filter key the contracts
// registry gives its screen (`__tests__/filter-labels.test.ts`).

import type { TFunction } from "i18next";

export function customerFilterLabels(t: TFunction): Record<string, string> {
  return {
    q: t("sales.customers.search"),
    tier: t("sales.customers.filterTier"),
    status: t("sales.customers.filterStatus"),
    owner: t("sales.customers.filterOwner"),
    credit_hold: t("sales.customers.filterCreditHold"),
    needs_next_step: t("sales.customers.filterNeedsNextStep"),
    tag: t("sales.customers.filterTag"),
  };
}

export function quoteFilterLabels(t: TFunction): Record<string, string> {
  return {
    customer: t("sales.quotes.filterCustomer"),
    status: t("sales.quotes.filterStatus"),
    origin: t("sales.quotes.filterOrigin"),
    owner: t("sales.quotes.filterOwner"),
    off_list: t("sales.quotes.filterOffList"),
    created_from: t("sales.quotes.filterFrom"),
    created_to: t("sales.quotes.filterTo"),
  };
}

export function orderFilterLabels(t: TFunction): Record<string, string> {
  return {
    customer: t("sales.orders.filterCustomer"),
    status: t("sales.orders.filterStatus"),
    facility: t("sales.orders.filterFacility"),
  };
}
